export const customEmojis = [
    {
        shortNames: ['bone'],
        name: 'Bone',
        keywords: ["bone"],
        native: '🦴',
        unified: '1F9B4'
    },
    {
        shortNames: ['tooth'],
        name: 'Tooth',
        keywords: ["tooth"],
        native: '🦷',
        unified: '1F9B7'
    },
    {
        shortNames: ['goggles'],
        name: 'Goggles',
        keywords: ["goggles"],
        native: '🥽',
        unified: '1F97D'
    },
    {
        shortNames: ['lab', 'coat'],
        name: 'Lab Coat',
        keywords: ["lab", "coat"],
        native: '🥼',
        unified: '1F97C'
    },
    {
        shortNames: ['thread'],
        name: 'Thread',
        keywords: ['thread'],
        native: '🧵',
        unified: '1F9F5'
    },
    {
        shortNames: ['yarn'],
        name: 'Yarn',
        keywords: ['yarn'],
        native: '🧶',
        unified: '1F9F6'
    },
    {
        shortNames: ['brick'],
        name: 'Brick',
        keywords: ['brick'],
        native: '🧱',
        unified: '1F9F1'
    },
    {
        shortNames: ['toolbox'],
        name: 'Toolbox',
        keywords: ['toolbox'],
        native: '🧰',
        unified: '1F9F0'
    },
    {
        shortNames: ['magnet'],
        name: 'Magnet',
        keywords: ['magnet'],
        native: '🧲',
        unified: '1F9F2'
    },
    {
        shortNames: ['test', 'tube'],
        name: 'Test Tube',
        keywords: ['test', 'tube'],
        native: '🧪',
        unified: '1F9EA'
    },
    {
        shortNames: ['zzz'],
        name: 'Zzz',
        keywords: ['Zzz', 'bedtime', 'boring', 'sleep'],
        native: '💤',
        unified: '1F4A4'
    },
    {
        shortNames: [''],
        name: 'Man Superhero',
        keywords: [''],
        native: '🦸‍♂️',
        unified: '1F9B8-200D-2642-FE0F'
    },
    {
        shortNames: [''],
        name: 'Woman Superhero',
        keywords: [''],
        native: '🦸‍♀️',
        unified: '1F9B8-200D-2640-FE0F'
    },
    {
        shortNames: [''],
        name: 'Backpack',
        keywords: [''],
        native: '🎒',
        unified: '1F392'
    },
    {
        shortNames: [''],
        name: 'Luggage',
        keywords: [''],
        native: '🧳',
        unified: '1F9F3'
    },
    {
        shortNames: [''],
        name: 'Diving Mask',
        keywords: [''],
        native: '🤿',
        unified: '1F93F'
    },
    {
        shortNames: [''],
        name: 'Abacus',
        keywords: [''],
        native: '🧮',
        unified: '1F9EE'
    },
    {
        shortNames: [''],
        name: 'Skull and Crossbones',
        keywords: [''],
        native: '☠️',
        unified: '2620-FE0F'
  },
  {
    shortNames: [''],
    name: 'Thumbs Up',
    keywords: [''],
    native: '👍🏻',
    unified: '1F44D-1F3FB'
  },
  {
    shortNames: [''],
    name: 'Thumbs Up: Medium Skin Tone',
    keywords: [''],
    native: '👍🏽',
    unified: '1F44D-1F3FD'
  },
  {
    shortNames: [''],
    name: 'Thumbs Up: Medium-Dark Skin Tone',
    keywords: [''],
    native: '👍🏾',
    unified: '1F44D-1F3FE'
  },
  {
    shortNames: [''],
    name: 'Thumbs Up: Dark Skin Tone',
    keywords: [''],
    native: '👍🏿',
    unified: '1F44D-1F3FF'
  },
  {
    shortNames: [''],
    name: 'Firecracker',
    keywords: [''],
    native: '🧨',
    unified: '1F9E8'
  },
  {
    shortNames: [''],
    name: 'Yawning Face',
    keywords: [''],
    native: '🥱',
    unified: '1F971'
  }
  ,
  {
    shortNames: [''],
    name: 'Auto Rickshaw',
    keywords: [''],
    native: '🛺',
    unified: '1F6FA'
  }
  ,
  {
    shortNames: [''],
    name: 'Parachute',
    keywords: [''],
    native: '🪂',
    unified: '1FA82'
  }
  ,
  {
    shortNames: [''],
    name: 'Adhesive Bandage',
    keywords: [''],
    native: '🩹',
    unified: '1FA79'
  },
  {
    shortNames: [''],
    name: 'Diya Lamp',
    keywords: [''],
    native: '🪔',
    unified: '1FA94'
  },
  {
    shortNames: [''],
    name: 'Manual Wheelchair',
    keywords: [''],
    native: '🦽',
    unified: '1F9BD'
  },
  {
    shortNames: [''],
    name: 'Pinching Hand',
    keywords: [''],
    native: '🤏',
    unified: '1F90F'
  },
  {
    shortNames: [''],
    name: 'Ice',
    keywords: [''],
    native: '🧊',
    unified: '1F9CA'
  },
  {
    shortNames: [''],
    name: 'Man Kneeling',
    keywords: [''],
    native: '🧎‍♂️',
    unified: '1F9CE-200D-2642-FE09'
  },
  {
    shortNames: [''],
    name: 'Woman Kneeling',
    keywords: [''],
    native: '🧎‍♀️',
    unified: '1F9CE-200D-2640-FE0F'
  },
  {
    shortNames: [''],
    name: 'Male Sign',
    keywords: [''],
    native: '♂️',
    unified: '2642-FE0F'
  },
  {
    shortNames: [''],
    name: 'Female Sign',
    keywords: [''],
    native: '♀️',
    unified: '2640-FE09'
  },
  {
    shortNames: [''],
    name: 'Soap',
    keywords: [''],
    native: '🧼',
    unified: '1F9FC'
  },
  {
    shortNames: [''],
    name: 'Sponge',
    keywords: [''],
    native: '🧽',
    unified: '1F9FD'
  },
  {
    shortNames: [''],
    name: 'Roll of Paper',
    keywords: [''],
    native: '🧻',
    unified: '1F9FB'
  },
];
